module.exports = __webpack_public_path__ + "../assets/fonts/NeutraDisplay-Medium.9420c528a8595ff6f9641e14ddb61336.otf";